<template>
    <div class="filter-wrapper">
        <label for="filtro" v-text="$t('filtrar-por')" />
        <SelectBox :items="options" :placeholder="''" :icons="false" />
    </div>
</template>

<script>
import SelectBox from './form/SelectBox.vue';

export default {
    props: {},
    data() {
        return {
            options: ['Nome', 'Status', 'Atendimento'],
        };
    },
    components: {
        SelectBox,
    },
    computed: {},
};
</script>

<style lang="scss" scoped>
// @import "../../../styles.scss";

.filter-wrapper {
    width: 100%;
    display: flex;
    position: relative;
    border-radius: 3px;
}
.filter-wrapper select {
    border: none;
    padding: 12px 5px;
    color: $darker-gray-color;
}
.filter-wrapper label {
    top: -25px;
    border: none;
    background: transparent;
    color: $darker-gray-color;
    font-weight: 600;
    position: absolute;
    // padding: 0 15px;
}
</style>
